import StoreBtn from '@src/components/Molecules/Store/StoreBtn';
import { devices } from '@src/styles/theme';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
import Group from '@src/assets/imgs/group.svg';
import useOSDetect from '@src/hooks/useOsDetect';
type Props = {
  isListPage: boolean;
};

const Bottom = ({ isListPage }: Props) => {
  const isMobileOs = useOSDetect();

  const onAnchorStore = () => {
    if (isMobileOs === 'android') {
      window.open(
        'https://play.google.com/store/apps/details?id=org.techtown.pple&pli=1'
      );
    } else {
      window.open(
        'https://apps.apple.com/kr/app/%ED%94%BC%ED%94%8C/id1621815801'
      );
    }
  };
  return (
    <>
      {/* 리스트에서 보여지는경우 */}
      {/* {isListPage && (
        <FlexSpace>
          <AppUseText>
            <AppText>앱으로 편리하게 이용해보세요.</AppText>
            <div onClick={onAnchorStore}>
              <AppDownText>다운로드 받기</AppDownText>
            </div>
          </AppUseText>
          <StoreBtn isColumn={true} />
        </FlexSpace>
      )} */}
      {/* 작성에서 보여지는 경우 */}
      {
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FlexSpace
              style={{
                marginBottom: 20,
                cursor: 'pointer',
              }}
              onClick={() => {
                window.open(
                  'https://davidkim2028.notion.site/2df3b4387246481490b4bba4ee0a8ee9',
                  '_blank'
                );
              }}
            >
              <AppUseText>
                <AppText style={{ width: '100%', fontSize: 18 }}>
                  피플의 따듯한 여정에 동참해주세요!
                  <br />
                  후원 하러 가기
                </AppText>
                {/* <div>
                  <AppDownText
                    style={{
                      marginTop: 10,
                    }}
                  >
                    후원시 약 <span style={{ fontWeight: 'bold' }}>166명</span>
                    에게 사연이 더 알려집니다!
                  </AppDownText>
                </div> */}
              </AppUseText>
              <SvgImage as={Group} width={100} height={100} alt={'donation'} />
            </FlexSpace>
            <FlexSpace>
              <AppUseText>
                <AppText>앱으로 편리하게 이용해보세요.</AppText>
                <div onClick={onAnchorStore}>
                  <AppDownText>다운로드 받기</AppDownText>
                </div>
              </AppUseText>
              <StoreBtn isColumn={true} />
            </FlexSpace>
          </div>
        </>
      }
    </>
  );
};

const FlexSpace = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  background-color: ${({ theme }) => theme.commonColor.white};
  border-radius: 10px;
  padding: 10px 20px;
`;

const AppUseText = styled.div`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: ${({ theme }) => theme.commonColor.black};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media ${devices.laptop} {
    font-size: 12px;
  }
  @media ${devices.laptopL} {
    font-size: 14px;
  }
`;

const AppDownText = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  font-weight: 400;
  font-size: 12px;
  letter-spacing: -0.6px;
  margin-top: 5px;
`;

const AppText = styled.div`
  font-style: normal;
  font-weight: 700;
  width: 140px;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: -0.6px;
  color: ${({ theme }) => theme.commonColor.black};
  @media ${devices.tablet} {
    font-size: 14px;
  }
`;

const SvgImage = styled.svg``;

export default Bottom;
